import React from "react";
import {
    SovosCard,
    SovosDivider,
    SovosTypography,
    SovosLinearProgress,
    SovosList,
    SovosGrid,
    SovosIcon,
    SovosChipFilter,
    SovosTooltip,
} from "mosaic-react";
import { CheckCircleRounded, ErrorRounded, ErrorOutline } from "mosaic-react-icons";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { useTheme } from "mosaic-react/styles";
import { ActionButtonOutlined } from "./ActionButtonOutlined";

const renderFileFeedBack = (isFileExists, i18n) => {
    if (typeof isFileExists === "undefined" || isFileExists === null) {
        return (
            <SovosTypography
                sx={{ textAlign: "right", flexGrow: "1" }}
            >{i18n`Unchecked`}</SovosTypography>
        );
    }

    const _color = isFileExists ? "success" : "error";

    return (
        <SovosGrid
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                flexGrow: "0",
                alignItems: "center",
                minWidth: "129.77px",
            }}
        >
            <SovosIcon color={_color} sx={{ marginRight: "10px" }}>
                {" "}
                {isFileExists ? <CheckCircleRounded /> : <ErrorRounded />}
            </SovosIcon>
            <span>{isFileExists ? i18n`Provided` : i18n`Missed`}</span>
        </SovosGrid>
    );
};

const dataListRender = (
    row,
    mandatoryTagColor,
    history,
    i18n,
    params,
    fiscalYearOfGenEntry,
    theme,
) => {
    const link = `/${params.locale}/${params.projectId}/${fiscalYearOfGenEntry || params.fiscalYear}/${params.importId}/nc_audit`;
    return (
        <SovosGrid
            container
            spacing={2}
            key={row.entity}
            sx={{ display: "flex", flexDirection: "column", padding: "10px" }}
        >
            <SovosGrid
                item
                xs
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    maxHeight: "45px",
                    minHeight: "45px",
                    alignItems: "center",
                }}
            >
                <SovosGrid
                    sx={{
                        display: "flex",
                        flexGrow: "1",
                        width: "100%",
                        maxHeight: "24px",
                        alignItems: "center",
                    }}
                >
                    <SovosTypography sx={{ minWidth: "300px" }} variant={"h6"}>
                        {(row?.entity || "").replace(/([A-Z])/g, " $1").trim()}
                    </SovosTypography>

                    <SovosTypography sx={{ minWidth: 114, textAlign: "left" }}>
                        <SovosChipFilter
                            sx={{
                                fontSize: "small",
                                height: 20,
                                marginLeft: 2,
                                background: row.isMandatory ? mandatoryTagColor : "",
                            }}
                            label={row.isMandatory ? i18n`Mandatory` : i18n`Optional`}
                        />
                    </SovosTypography>
                </SovosGrid>

                {row?.auditStatus ? (
                    <SovosGrid
                        sm={"auto"}
                        sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
                    >
                        <ActionButtonOutlined
                            history={history}
                            link={link}
                            title={"Audit result"}
                            i18n={i18n}
                        />
                        <SovosGrid
                            sm={"auto"}
                            sx={{
                                display: "flex",

                                alignItems: "center",
                            }}
                        >
                            <SovosTooltip
                                title={i18n`Potential Audit findings need attention. You might wanna check it`}
                            >
                                <SovosIcon
                                    sx={{ marginRight: "10px" }}
                                    color={"warning"}
                                    children={<ErrorOutline />}
                                />
                            </SovosTooltip>
                            <SovosTooltip
                                title={i18n`Potential Audit findings need attention. You might wanna check it`}
                            >
                                <SovosTypography>Need attention</SovosTypography>
                            </SovosTooltip>
                        </SovosGrid>
                    </SovosGrid>
                ) : (
                    <SovosGrid sm={"auto"} sx={{ display: "flex", justifyContent: "flex-end" }}>
                        {!row.status && row?.isMandatory && (
                            <ActionButtonOutlined
                                i18n={i18n}
                                link={`activity`}
                                title={"Data Upload"}
                                history={history}
                            />
                        )}
                        {renderFileFeedBack(row.status, i18n)}
                    </SovosGrid>
                )}
            </SovosGrid>
        </SovosGrid>
    );
};

//If the name of this function is changed, it must also be updated in the GeneratorDataFile model in the web-api.
const GeneratorListDetails = (props) => {
    const { history, i18n, params } = useGlobalValue();
    const { detailPanel, Status, fiscalYear: fiscalYearOfGenEntry } = props || {};
    const { data } = detailPanel || {};
    const theme = useTheme();
    const mandatoryTagColor = theme.palette.grey.A100;

    return (
        <SovosCard sx={{ margin: "20px" }}>
            <SovosTypography variant="h3">
                <b>{i18n`Validation completed`}</b>
            </SovosTypography>

            <SovosDivider sx={{ marginTop: "15px", marginBottom: "15px" }} />

            <SovosTypography sx={{ marginBottom: "10px" }}>
                <b>
                    {i18n`Checking if all mandatory files are provided and any potencial critical audit finding`}
                </b>
            </SovosTypography>

            <SovosTypography>100%</SovosTypography>
            <SovosLinearProgress
                value={100}
                variant="determinate"
                aria-label="Progress pre validation check"
            />

            <SovosDivider sx={{ marginTop: "15px", marginBottom: "15px" }} />

            <SovosList
                data={data || []}
                rowRenderer={(row) =>
                    dataListRender(
                        row,
                        mandatoryTagColor,
                        history,
                        i18n,
                        params,
                        fiscalYearOfGenEntry,
                        theme,
                    )
                }
                sx={{
                    padding: 0,
                    "& .MuiListItem-root": {
                        height: "auto",
                    },
                    height: "450px",
                    overflowY: "scroll",
                }}
            />
            {Status?.value === 1 && (
                <>
                    <SovosDivider sx={{ marginTop: "15px", marginBottom: "15px" }} />
                    <SovosTypography variant="h3">
                        <b>{i18n`Process Done`}</b>
                    </SovosTypography>
                </>
            )}
        </SovosCard>
    );
};

export default GeneratorListDetails;
